import React from 'react';

import { Dialog, Typography } from '@material-ui/core';

import DialogGrid from 'containers/DialogGrid/DialogGrid';

import useStyles from './SheetsTimerHelpDialog.styles';

type Props = {
  open: boolean;
  onClose: () => void;
};

const SheetsTimerHelpDialog: React.FC<Props> = ({ open, onClose }) => {
  const classes = useStyles();

  return (
    <Dialog onClose={onClose} maxWidth='sm' open={open}>
      <DialogGrid cancelClick={onClose} hideCancelButton okClick={onClose} okLabel='Rozumiem' title='Czas trwania egzaminu maturalnego'>
        <div className={classes.root}>
          <div>
            <Typography className={classes.sectionTitle} color='primary'>
              Typowe czasy egzaminów pisemnych (Formuła 2023)
            </Typography>
            <ul className={classes.list}>
              <li>
                <Typography>Język polski (poziom podstawowy): 240 minut</Typography>
              </li>
              <li>
                <Typography>Język polski (poziom rozszerzony): 210 minut</Typography>
              </li>
              <li>
                <Typography>Matematyka (poziom podstawowy i rozszerzony): 180 minut</Typography>
              </li>
              <li>
                <Typography>Język obcy nowożytny (poziom podstawowy): 120 minut</Typography>
              </li>
              <li>
                <Typography>Język obcy (poziom rozszerzony): 150 minut</Typography>
              </li>
              <li>
                <Typography>Język obcy (poziom dwujęzyczny): 180 minut</Typography>
              </li>
              <li>
                <Typography>
                  Pozostałe przedmioty na poziomie rozszerzonym (m.in. biologia, chemia, fizyka, geografia, historia): 180 minut
                </Typography>
              </li>
              <li>
                <Typography>Informatyka (poziom rozszerzony): 210 minut</Typography>
              </li>
            </ul>
          </div>
          <div>
            <Typography className={classes.sectionTitle} color='primary'>
              Dodatkowy czas dla osób z niepełnosprawnościami
            </Typography>
            <Typography className={classes.note}>
              Zgodnie z przepisami CKE, w części pisemnej egzaminu maturalnego można otrzymać przedłużenie czasu z danego
              przedmiotu nie więcej niż o 30 minut na każdy arkusz egzaminacyjny. Dodatkowy czas można wykorzystać na
              rozwiązywanie zadań lub przerwy, w zależności od indywidualnych potrzeb. Decyzję o dostosowaniach podejmuje
              dyrektor szkoły na podstawie dokumentacji (np. orzeczenia o potrzebie kształcenia specjalnego lub zaświadczenia
              lekarskiego).
            </Typography>
          </div>
        </div>
      </DialogGrid>
    </Dialog>
  );
};

export default SheetsTimerHelpDialog;
